import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import {responsiveStoreEnhancer} from 'redux-responsive'
import ReduxThunk from 'redux-thunk'
import { browserHistory } from 'react-router';

import createRoutes from './routes';

import './index.scss';

// Store
import rootReducer from './state/reducers';

const store = createStore(rootReducer, compose(
    responsiveStoreEnhancer,
    applyMiddleware(ReduxThunk)
));

ReactDOM.render(
    <Provider store={store}>
        { createRoutes(browserHistory, store) }
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js